<template>
  <div class="w-full">
    <vs-row vs-justify="center" v-if="isTrigger">
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
        <Number
          v-model="questionsByPage[index].properties.limit"
          :label="$t('MODULE.originSelect.limit')"
          :disabled="true"
        ></Number>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="4" vs-sm="12" class="text-left">
        <vs-button color="success" type="border" @click="OpenPopup()">{{
          $t("MODULE.originSelect.btnOrigin")
        }}</vs-button>
      </vs-col>
    </vs-row>
    <vs-row vs-justify="center">
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
        <vs-select
          autocomplete
          class="mt-5 w-full px-0"
          v-model="questionsByPage[index].query.type"
          :label="$t('MODULE.originSelect.typeQuery')"
        >
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in queries" />
        </vs-select>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
        <vs-select
          autocomplete
          class="mt-5 w-full pl-3"
          :label="$t('MODULE.originSelect.typeAction')"
          v-model="questionsByPage[index].query.action"
          @change="validateAction(questionsByPage[index].query.action, false)"
        >
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in actions" />
        </vs-select>
        <vs-button
          v-if="questionsByPage[index].query.action === 'trigger'"
          class="ml-3"
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-link-2"
          @click="validateAction(questionsByPage[index].query.action, true)"
        ></vs-button>
      </vs-col>
    </vs-row>

    <vs-row class="mt-5" vs-justify="center">
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" vs-sm="12" class="text-left">
        <vs-textarea :label="$t('MODULE.originSelect.query')" v-model="questionsByPage[index].query.q" />
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" vs-sm="12" class="text-left">
        <vs-input
          class="w-full"
          :label="$t('MODULE.originSelect.messagge')"
          :placeholder="$t('MODULE.originSelect.messagge')"
          v-model="questionsByPage[index].query.message"
        />
      </vs-col>
    </vs-row>
  </div>
</template>

<script type="text/javascript">
import Default from "../../componentsToQuestions/DefaultSelect.vue";
import Number from "../../components/Number.vue";
import { mapState, mapMutations } from "vuex";
import { deleteListener } from "../../indexDB/dependencies.js";
import { getColumnsOrigin, deleteColumns } from "../../indexDB/logic.js";
export default {
  props: ["index"],
  components: { Default, Number },
  data() {
    return {
      isMound: false,
      queries: [
        {
          value: "sql",
          text: "Sql"
        },
        {
          value: "fql",
          text: "Fql"
        }
      ],
      actions: [
        {
          value: "none",
          text: "None"
        },
        {
          value: "start",
          text: "Start"
        },
        {
          value: "trigger",
          text: "Trigger"
        },
        {
          value: "disabled",
          text: "Disabled"
        }
      ]
    };
  },
  methods: {
    ...mapMutations("resource", ["UPDATE_STATE"]),
    /**
     * Valida el tipo de accción y abre un popup si la acción es trigger para vincular el resultado de otras acciones de tipo "select"
     * @param {string} action
     * @param {boolean} isOpenPopup
     */
    async validateAction(action, isOpenPopup) {
      if (action === "trigger" && isOpenPopup) {
        this.UPDATE_STATE({ key: "componentPopup", value: "OriginSelect" });
        this.UPDATE_STATE({ key: "activePopup", value: true });
        this.UPDATE_STATE({ key: "indexQuestion", value: this.index });
        let columns = await getColumnsOrigin();
        this.questionsByPage[this.index].properties.originKey = "N/A";
        this.questionsByPage[this.index].properties.limit = 1;

        const nameQuestion = this.questionsByPage[this.index].name;
        delete columns[nameQuestion];
        deleteColumns(columns);
      } else {
        if (this.questionsByPage[this.index].properties.originKey === "N/A") {
          this.questionsByPage[this.index].properties.originKey = "";
        }
        if (this.questionsByPage[this.index].properties.originKey === "") {
          this.questionsByPage[this.index].properties.limit = 0;
          // this.questionsByPage[this.index].properties.limit = 20;
        }

        deleteListener(this.questionsByPage[this.index].name);
      }
    },
    /**
     * Abre un popup para vincular el resultado de otras acciones de tipo "trigger"
     */
    OpenPopup() {
      this.UPDATE_STATE({ key: "componentPopup", value: "OriginSelectTigger" });
      this.UPDATE_STATE({ key: "activePopup", value: true });
      this.UPDATE_STATE({ key: "indexQuestion", value: this.index });
    }
  },
  computed: {
    ...mapState("resource", ["questionsByPage", "listOrigins"]),
    /**
     * Obtiene un array de las cabeceras del origen de datos.
     */
    arrayHeaders() {
      const header = this.questionsByPage[this.index].data;
      if (header[0]) {
        const getKeys = Object.keys(header[0]);
        return getKeys;
      }
      return [];
    },
    isTrigger() {
      return this.questionsByPage[this.index].query.action !== "trigger";
    }
  }
};
</script>
